export default function CorrectActtionIcon() {
  return (
    <>
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.07178"
          y="0.5"
          width="31"
          height="31"
          rx="15.5"
          fill="white"
        />
        <rect
          x="1.07178"
          y="0.5"
          width="31"
          height="31"
          rx="15.5"
          stroke="#7DFEB9"
        />
        <path
          d="M22.7593 12.0625L14.8843 19.9371L10.9468 16"
          stroke="#11A75C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
